import React from 'react';
import { OUTGOING_BRIDGE_KIND, OUTGOING_BRIDGE_LABELS } from '../../../../../../../../../constnats/outgoingBridge';
import { outgoingBridgesSchema } from '../../../../../../../../../schemas/outgoingBridge.schemas';
import { getBridgeDescriptorLabel, getOutgoingBridges } from '../../../../../../../../../utils/descriptor/outgoingBridges';
import type { DescriptorBridgesType } from '../../../../../../../../../utils/descriptor/outgoingBridges';
import type { DescriptorType } from '../../../../../../../../../types/descriptor.types';
import './bridgeIndicators.css';

type BridgeIndicatorsPropsType = {
    descriptor: DescriptorType;
    bridges: DescriptorBridgesType;
    onHighlightDescriptors: (ids: string[]) => void;
};

function BridgeIndicators({ descriptor, bridges, onHighlightDescriptors }: BridgeIndicatorsPropsType) {
    const { outgoing, incoming } = bridges;
    const outgoingEndDescriptorIds = outgoing.flatMap((bridge) => bridge.endDescriptor ? [bridge.endDescriptor.id] : []);
    const incomingStartDescriptorIds = incoming.map((startDescriptor) => startDescriptor.id);
    const invalid = outgoing.some((bridge) => !bridge.validEndDescriptor)
        || !outgoingBridgesSchema.safeParse(getOutgoingBridges(descriptor.outgoingBridges)).success;
    const outgoingDetails = outgoing.map((bridge) => {
        const descriptorLabel = bridge.endDescriptor ? getBridgeDescriptorLabel(bridge.endDescriptor) : bridge.endId;
        const details = `${bridge.validEndDescriptor ? '' : '(INVALID) '}${descriptorLabel}`;
        if (bridge.kind === OUTGOING_BRIDGE_KIND.SAME_VARIABLE) {
            const name = bridge.name.trim();
            return `${details} (${OUTGOING_BRIDGE_LABELS[bridge.kind]}${name ? `: ${name}` : ''})`;
        }
        return details;
    });

    function highlightNeighbours(neighbours: string[]) {
        onHighlightDescriptors([...new Set([descriptor.id, ...neighbours])]);
    }

    return (
        <>
            {outgoing.length > 0 && (
                <button
                    type="button" className={`descriptorBridges__indicator${invalid ? ' legend-error' : ''}`}
                    title={`Outgoing bridges to: ${outgoingDetails.join(', ')}`}
                    onMouseEnter={() => highlightNeighbours(outgoingEndDescriptorIds)}
                    onMouseLeave={() => onHighlightDescriptors([])}
                    onFocus={() => highlightNeighbours(outgoingEndDescriptorIds)}
                    onBlur={() => onHighlightDescriptors([])}
                    onDoubleClick={(event) => event.stopPropagation()}
                >
                    <b>Outgoing bridges:</b> {outgoing.length} 
                </button>
            )}
            {incoming.length > 0 && (
                <button
                    type="button" className="descriptorBridges__indicator"
                    title={`Incoming bridges from: ${incoming.map(getBridgeDescriptorLabel).join(', ')}`}
                    onMouseEnter={() => highlightNeighbours(incomingStartDescriptorIds)}
                    onMouseLeave={() => onHighlightDescriptors([])}
                    onFocus={() => highlightNeighbours(incomingStartDescriptorIds)}
                    onBlur={() => onHighlightDescriptors([])}
                    onDoubleClick={(event) => event.stopPropagation()}
                >
                    <b>Incoming bridges:</b> {incoming.length}
                </button>
            )}
        </>
    );
}

export default BridgeIndicators;
